import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 15px;
`;

export const some = '';
